import { Link } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Truck } from "lucide-react";

export default function DriverLayout({ children }) {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="driver-layout">
      <header className="h-16 border-b border-slate-200 bg-white sticky top-0 z-20">
        <div className="h-full max-w-xl mx-auto px-4 flex items-center justify-between">
          <Link to="/driver" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[#002FA7] grid place-items-center text-white">
              <Truck className="w-5 h-5" strokeWidth={2.4} />
            </div>
            <div>
              <div className="font-bold text-lg leading-tight" style={{ fontFamily: "Outfit" }}>
                Fleet Sheet
              </div>
              <div className="text-[10px] uppercase tracking-wider text-slate-500">Driver</div>
            </div>
          </Link>
          <UserButton afterSignOutUrl="/" />
        </div>
      </header>
      <main className="max-w-xl mx-auto px-4 py-5 pb-16">{children}</main>
    </div>
  );
}
